'use client';

import { SessionProvider } from "next-auth/react";
import { ReactNode } from "react";
import { toast } from "sonner";
import { BareFetcher, SWRConfig, SWRConfiguration } from 'swr';
import { FasterUrlUpdateProvider } from "./hooks/useFastUrlUpdate";
import { NotificationTokenProvider } from "./hooks/useNotificationToken";
import { TooltipProvider } from "./ui/imported/tooltip";
import Spinner from "./ui/utils/Spinner";


declare module 'swr' {
    interface SWRConfiguration_Custom extends SWRConfiguration {
        /** override default fetcher with custom function / server-action */
        fetcher?: BareFetcher<any> | undefined,
        /**
         * @link https://swr.vercel.app/docs/revalidation

            - Disabled by default: refreshInterval = 0
            - If set to a number, polling interval in milliseconds
            - If set to a function, the function will receive the latest data and should return the interval in milliseconds
         *  @default   60 * 60 * 1000*/
        refreshInterval?: number | ((latestData: any) => number) | undefined,
        /** @default false */
        revalidateOnFocus?: boolean | undefined,
    }
}


export function Providers({ children }: { children: ReactNode }) {
    return (
        <SessionProvider refetchInterval={ 60 * 60 }>
            <SWRConfig value={ {
                fetcher: (resource, init) => fetch(resource, init).then(res => res.json()),
                onError: (err) => toast.error(err.message || err?.toString() || err),
                refreshInterval: 60 * 60 * 1000,
                revalidateOnFocus: false,
                onLoadingSlow: () => {
                    toast.info(<>
                        <Spinner className="text-6xl" />
                        <p className="text-sm">זמן טעינה ארוך מהרגיל, ייתכן עומס על השרתים או שהאינטרנט שלך איטי..</p>
                    </>
                        , { "duration": 10000, "dismissible": true })
                }
            } }>
                <TooltipProvider delayDuration={ 200 } >
                    <NotificationTokenProvider>
                        <FasterUrlUpdateProvider>
                            { children }
                        </FasterUrlUpdateProvider>
                    </NotificationTokenProvider>
                </TooltipProvider>
            </SWRConfig>
        </SessionProvider>
    );
}